/*
  Maluhia – Warenkorb-Drawer
  Upsell-Hinzufügen + Rabattcode.

  Wichtig: Dawn ersetzt bei jeder Warenkorb-Änderung die innerHTML von #CartDrawer
  (siehe cart-drawer.js -> getSectionsToRender). Direkt gebundene Listener gehen dabei
  verloren, deshalb läuft hier alles über delegierte Listener auf document.
  Preise, Versandschwelle und Artikelzähler rechnet Liquid serverseitig neu — hier
  wird bewusst NICHT im Browser gerechnet.
*/
(function () {
  'use strict';

  var ADDED_MS = 1600;

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  /* ---------- Upsell ---------- */

  function addUpsell(btn) {
    var id = btn.getAttribute('data-maluhia-add');
    if (!id || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    var label = btn.getAttribute('data-maluhia-label') || btn.textContent.trim();
    var cd = drawer();

    btn.classList.add('is-loading');
    btn.disabled = true;

    var body = {
      items: [{ id: Number(id), quantity: 1 }],
    };

    // Dawn liefert die neu gerenderten Sections gleich mit zurück,
    // damit der Drawer ohne zweiten Request aktualisiert werden kann.
    if (cd && typeof cd.getSectionsToRender === 'function') {
      body.sections = cd.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);

        // Bestätigung zeigen, BEVOR der Drawer neu rendert – sonst ist der Button weg.
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = 'Hinzugefügt';

        window.setTimeout(function () {
          if (cd && data.sections) {
            cd.renderContents(data);
          } else {
            window.location.reload();
          }
        }, ADDED_MS);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.textContent = label;
      });
  }

  /* ---------- Rabattcode ---------- */

  function applyDiscount(scope) {
    var input = scope.querySelector('[data-maluhia-discount-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) {
      input.focus();
      return;
    }
    // Die AJAX-Warenkorb-API kann keine Rabattcodes einlösen.
    // /discount/CODE setzt den Code und leitet weiter.
    window.location.href =
      window.Shopify.routes.root + 'discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  }

  /* ---------- Delegation ---------- */

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-maluhia-add]');
    if (add) {
      e.preventDefault();
      addUpsell(add);
      return;
    }

    var toggle = e.target.closest('[data-maluhia-discount-toggle]');
    if (toggle) {
      e.preventDefault();
      var wrap = toggle.closest('[data-maluhia-discount]');
      if (!wrap) return;
      var open = wrap.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var field = wrap.querySelector('[data-maluhia-discount-input]');
        if (field) field.focus();
      }
      return;
    }

    var apply = e.target.closest('[data-maluhia-discount-apply]');
    if (apply) {
      e.preventDefault();
      var scope = apply.closest('[data-maluhia-discount]');
      if (scope) applyDiscount(scope);
    }
  });

  // Enter im Rabattfeld löst ein, statt das Warenkorb-Formular abzuschicken.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var field = e.target.closest('[data-maluhia-discount-input]');
    if (!field) return;
    e.preventDefault();
    var scope = field.closest('[data-maluhia-discount]');
    if (scope) applyDiscount(scope);
  });
})();
